// Vendors
import { thunk } from 'redux-thunk';

// Backend
import apiMiddleware from './apiMiddleware';
import authErrorMiddleware from './authErrorMiddleware';

const middleware = [thunk, apiMiddleware, authErrorMiddleware];

export default middleware;
